import { useEffect, useState } from "react";
import { motion } from "framer-motion";

const LINKS = [
  { label: "Botanicals", href: "#botanicals" },
  { label: "Science", href: "#science" },
  { label: "Sourcing", href: "#sourcing" },
  { label: "Partners", href: "#partners" },
];

export const scrollToSection = (href) => {
  const el = document.querySelector(href);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -70, duration: 1.4 });
  else el.scrollIntoView({ behavior: "smooth" });
};

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.9, delay: 0.2, ease: [0.16, 1, 0.3, 1] }}
      data-testid="site-navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-500 ${
        scrolled ? "glass-dark" : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-[70px] flex items-center justify-between">
        <button
          data-testid="nav-logo"
          onClick={() => window.__lenis?.scrollTo(0, { duration: 1.4 })}
          className="font-display text-2xl tracking-tight text-[#F5F1E8] hover:text-[#C5A880] transition-colors duration-300"
        >
          Sage <span className="text-[#C5A880] italic">&</span> Spirit
        </button>
        <nav className="hidden md:flex items-center gap-10">
          {LINKS.map((l) => (
            <button
              key={l.href}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              onClick={() => scrollToSection(l.href)}
              className="text-xs uppercase tracking-[0.2em] text-[#F5F1E8]/70 hover:text-[#C5A880] transition-colors duration-300"
            >
              {l.label}
            </button>
          ))}
        </nav>
        <button
          data-testid="nav-cta-button"
          onClick={() => scrollToSection("#partners")}
          className="rounded-full bg-[#C5A880] text-[#062516] text-xs uppercase tracking-[0.18em] font-medium px-6 py-2.5 hover:bg-[#D9BE93] transition-colors duration-300"
        >
          Become a Partner
        </button>
      </div>
    </motion.header>
  );
};

export default Navbar;
